import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useAppSelector } from "../../Store/Hooks";
import SignalHistoryDetail from "../MyPortfolioAccounts/SignalHistoryDetail";

type LocationState = { from?: string };

/** Standalone route for a direct/shareable link to one account's signal
 * history (§8.1). The in-app path (Actions → History) shows the same
 * SignalHistoryDetail in place instead of navigating here — see
 * ActionsTab.tsx — so this page exists only for a link that lands cold. */
const AccountSignalHistoryPage: React.FC = () => {
  const { accountId, orgSlug } = useParams<{
    accountId: string;
    orgSlug?: string;
  }>();
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = (location.state as LocationState | null) ?? {};

  const withOrg = (path: string) => {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return orgSlug ? `/${orgSlug}${normalizedPath}` : normalizedPath;
  };

  const { summary } = useAppSelector(state => state.signalHistory);
  const accountName = summary.find(
    a => a.account_id === accountId
  )?.account_name;

  if (!accountId) return null;

  return (
    <div className="p-6">
      <SignalHistoryDetail
        accountId={accountId}
        accountName={accountName}
        onBack={() =>
          navigate(
            locationState.from || withOrg("/my-portfolio-accounts?tab=actions")
          )
        }
      />
    </div>
  );
};

export default AccountSignalHistoryPage;
